import { useEffect } from 'react';
import { useBreadcrumbContext } from '../../../contexts/BreadcrumbContext';
import { useSurveyReport } from './useSurveyReport';

/**
 * Sets breadcrumb metadata with the report title for the given report ID.
 * Constructs a title like "Survey Report - {date}" for the report detail page.
 */
export const useReportBreadcrumb = (reportId: string | undefined) => {
  const { setMetadata } = useBreadcrumbContext();

  const { data } = useSurveyReport(reportId ?? '', { enabled: !!reportId });
  const report = data?.data;

  useEffect(() => {
    if (report) {
      const dateStr = report.generatedAt
        ? new Date(report.generatedAt).toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
          })
        : 'Unknown Date';
      setMetadata({ reportTitle: `Survey Report - ${dateStr}` });
    }
  }, [report, setMetadata]);

  useEffect(() => {
    return () => {
      setMetadata({ reportTitle: undefined });
    };
  }, [reportId, setMetadata]);
};
